import create from 'zustand';
import { immer } from 'zustand/middleware/immer'
import {SortParams} from "@/components/SortIndicator";

export type UserRestrictions = {
  id: number,
  project_category_id: number,
  category_restriction_code: string,
  category_restriction_value: number,
  tab_id: number
};

export type User = {
  id: number,
  roll: string,
  last_visited_path?: string | null;
  last_name: string;
  first_name: string;
  email_address: string;
  logged_in_date: string;
  is_changed_password: number;
  user_restrictions: UserRestrictions[];
  has_drm_pf_credentials: boolean;
  group_id: number;
  display_group_name: string;
};

export const UserListHeader = [
  {
    headerName:'ID',
    sortItemName: 'id',
  },
  {
    headerName:'グループ',
    sortItemName: 'group_id',
  },
  {
    headerName:'権限',
    sortItemName: 'roll',
  },
  {
    headerName:'メールアドレス',
    sortItemName: 'email_address',
  },
  {
    headerName:'姓',
    sortItemName: 'last_name',
  },
  {
    headerName:'名',
    sortItemName: 'first_name',
  },
  {
    headerName:'プロジェクト',
    sortItemName: '',
  },
  {
    headerName:'作成日',
    sortItemName: 'created',
  },
  {
    headerName:'有効期限',
    sortItemName: 'expiration_date',
  },
];

const initState = {
  queryParams: undefined,
  childSubmit: () => {
  },
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type UserStore = {
  user: User | undefined;
  setUser: (user: User | undefined) => void;
  setIsChangedPassword: (isChanged: number) => void;
  setUserRestrictions: (userRestrictions: UserRestrictions[]) => void;

  queryParams: any | undefined;
  setQueryParams: (any: any | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: UserStore['doSort']) => void;

};

export const useUserStore = create<UserStore>()(
  immer((set) => ({
    user: undefined,

    setUser: (user) =>
      set((state) => ({
        user: user,
      })),
    setIsChangedPassword: (isChanged: number) =>
      set((state) => {
        if (state.user) state.user.is_changed_password = isChanged;
      }),

    setUserRestrictions: (userRestrictions) =>
      set((state) => {
        if (state.user) state.user.user_restrictions = userRestrictions;
      }),

    ...initState,
    setQueryParams: (queryParams) =>
      set((state) => ({
        queryParams: queryParams,
      })),
    setSortParams: (sortParams) =>
      set((state) => ({
        sortParams: sortParams,
      })),
    setDoSort: (doSort) =>
      set((state) => ({
        doSort: doSort,
      }))
  }))
);
